import axios, { AxiosPromise } from 'axios';
import { IProject } from '../../../@types/model/masterData/project/project';


export default class ProjectHttpService {
    public static getProjectData() : AxiosPromise<Array<IProject>> {
        return axios.get(`${API_URL}/v1/Project/GetAllWeb`);
    }

    public static addOrUpdateProject(data : IProject) : AxiosPromise<IProject> {
        return axios.post(`${API_URL}/v1/Project/PostProject`, data);
    }

    public static deleteProject(projectId : number) : AxiosPromise<IProject> {
        return axios.delete(`${API_URL}/v1/Project/Delete`, {
            params : { projectId },
        });
    }
}
